import MediaController from "../../config/media.js";

import "./menu.js";

import "./footer.js";

import "./cookie-consent.js";

import "./custom/modals/coming-soon.js";

import "./custom/modals/join-the-wait.js";

import "./custom/modals/research.js";

const currentPage = document.body.dataset.page, pageScripts = {
    index: [ "./custom/utils/page-scroll-reveal.js", "./custom/index/index-section-2.js", "./custom/index/index-section-3.js", "./custom/index/index-section-4.js" ],
    "hvac-professionals": [ "./custom/utils/page-scroll-reveal.js", "./custom/hvac-professionals/hvac-professionals-section-4.js", "./custom/hvac-professionals/hvac-professionals-section-5.js", "./custom/hvac-professionals/hvac-professionals-section-9.js" ],
    contact: [ "./custom/utils/page-scroll-reveal.js", "./custom/contact/contact-section-1.js" ],
    homeowners: [ "./custom/utils/page-scroll-reveal.js", "./custom/homeowners/homeowners-section-2.js", "./custom/homeowners/homeowners-section-3.js", "./custom/homeowners/homeowners-section-5.js", "./custom/homeowners/homeowners-section-7.js", "./custom/homeowners/homeowners-section-10.js" ],
    "tech-specs": [ "./custom/tech-specs/sticky-visuals.js" ]
};

pageScripts[currentPage] && pageScripts[currentPage].forEach((scriptPath => {
    import(scriptPath).then((() => {})).catch((err => {}));
}));
